export const profileView: any = {
    accountTitle: 'Mi cuenta',    
    profileTitle: 'Mi perfil',
    email: {
        title: 'Email',
        action: 'Editar'
    },
    password: {
        title: 'Contraseña',
        action: 'Cambiar contraseña'
    },
    changePasswordConfirmationModal: {
        title: 'Cambio de contraseña',
        body: 'Tu contraseña ha sido actualizada.'
    },
    changeProfilePhotoConfirmationModal: {
        title: 'Foto de perfil',
        body: 'Tu foto de perfil ha sido actualizada.'
    },
    invalidImageTypeModal: {
        title: 'Foto de perfil',
        body: 'La foto seleccionada no es válida. Favor selecciona una foto de perfil con una de las siguientes extensiones: jpg, jpeg, png o gif.'
    },
    notLoggedIn: {
        subtitle: 'Haz login o crea una cuenta para manejar tu perfil.',
        benefitsTitle: 'Regístrate hoy GRATIS y podrás:',
        benefits: [ 'Comentar en las noticias', 'Recibir tus newsletters favoritos', 'Obtener artículos gratis cada mes']
    },
    modalActionButtons: {
        ok: 'OK'
    }
}    


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/profile/profile.static.data.ts